import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@canvas-logic/clp-shared-ui';

import RequestSuccessIcon from './icons/request-ok.svg?react';
import RequestErrorIcon from './icons/request-bad.svg?react';
import RequestPendingIcon from './icons/request-sending.svg?react';

import styles from './RequestQuote.module.css';

const statusData = {
  pending: {
    title: 'form.request-quote.pending.title',
    text: 'form.request-quote.pending.text',
    icon: <RequestPendingIcon />,
  },
  success: {
    title: 'form.request-quote.success.title',
    text: 'form.request-quote.success.text',
    icon: <RequestSuccessIcon />,
  },
  error: {
    title: 'form.request-quote.error.title',
    text: 'form.request-quote.error.text',
    icon: <RequestErrorIcon />,
  },
};

export const RequestQuoteFormStatus = ({ status }: { status: 'pending' | 'error' | 'success' }) => {
  const { t } = useTranslation('translation');

  const data = statusData[status];

  return (
    <div className={styles.formStatusContainer}>
      <div className={styles.statusIcon}>{data.icon}</div>
      <div className={styles.statusText}>
        <Typography variant="heading5" component="div">
          {t(data.title)}
        </Typography>
        <Typography variant="paragraph-sm" color="description">
          {t(data.text)}
        </Typography>
      </div>
    </div>
  );
};
